<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="2">
          <v-text-field
            :value="banksMonthlyTransaction.link"
            id="banksMonthlyTransItemLinkText"
            class="banks-monthly-trans-item-link-text"
            label="Link"
            @input="emitBankInfo({ link: $event })"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            :value="banksMonthlyTransaction.saiSection"
            id="banksMonthlyTransItemSAISectionText"
            class="banks-monthly-trans-item-sai-section-text"
            label="SAI Section"
            @input="emitBankInfo({ saiSection: $event })"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            :value="banksMonthlyTransaction.line"
            id="banksMonthlyTransItemLineText"
            class="banks-monthly-trans-item-line-text"
            label="Line"
            @input="emitBankInfo({ line: $event })"
            readonly
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="banksMonthlyTransaction.balPerBankStatement"
            id="banksMonthlyTransItemBalancePerBankStatementText"
            class="banks-monthly-trans-item-bal-per-bank-statement-text"
            label="Balance Per Bank Statement"
            @input="emitBankInfo({ balPerBankStatement: $event })"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="banksMonthlyTransaction.investment"
            id="banksMonthlyTransItemInvestmentText"
            class="banks-monthly-trans-item-investment-text"
            label="Investment"
            @input="emitBankInfo({ investment: $event })"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            :value="banksMonthlyTransaction.reconcilement"
            id="banksMonthlyTransItemReconcilementText"
            class="banks-monthly-trans-item-reconcilement-text"
            label="Reconcilement"
            @input="emitBankInfo({ reconcilement: $event })"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="banksMonthlyTransaction.adjBankBalance"
            id="banksMonthlyTransItemAdjBankBalanceText"
            class="banks-monthly-trans-item-adj-bank-balance-text"
            label="Adj Bank Balance"
            @input="emitBankInfo({ adjBankBalance: $event })"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="banksMonthlyTransaction.glBankBalance"
            id="banksMonthlyTransItemODGLBankBalanceText"
            class="banks-monthly-trans-item-od-gl-bank-balance-text"
            label="GL Bank Balance"
            @input="emitBankInfo({ glBankBalance: $event })"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="banksMonthlyTransaction.difference"
            id="saiMonthlyTransItemDifferenceText"
            class="banks-monthly-trans-item-difference-text"
            label="Difference"
            @input="emitBankInfo({ difference: $event })"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BanksMonthlyTransaction',
  components: {
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'banksMonthlyTrans-dialog',
    },
    banksMonthlyTransaction: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
  },
  methods: {
    emitBankInfo(updates) {
      this.$emit('updateBanksMonthlyTransaction', {
        ...this.banksMonthlyTransaction,
        ...updates,
      });
    },
  },
};
</script>
